const translations = {
  en: {
    // Navigation
    backToMenu: 'Back to Menu',
    viewInAR: 'View in AR',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    
    // Search and Filter
    searchPlaceholder: 'Search dishes, ingredients...',
    foundResults: 'Found {{count}} {{unit}}',
    dish: 'dish',
    dishes: 'dishes',
    allDishes: 'All Dishes',
    allCategories: 'All Categories',
    allStatus: 'All Status',
    
    // Categories
    appetizers: 'Appetizers',
    appetizersDesc: 'Start your culinary journey',
    mainCourse: 'Main Course',
    mainCourseDesc: 'Hearty and satisfying dishes',
    desserts: 'Desserts',
    dessertsDesc: 'Sweet endings to remember',
    beverages: 'Beverages',
    beveragesDesc: 'Refreshing drinks and cocktails',
    
    // Status
    active: 'Active',
    inactive: 'Inactive',
    draft: 'Draft',
    
    // Restaurant Menu Landing
    whereTraditionMeets: 'Where Tradition Meets Innovation',

    // Footer
    footerPhone: 'Phone',
    footerEmail: 'Email Address',
    footerAddress: 'Address',
    footerTerms: 'Terms & Policies',

    // DishCard
    viewInARButton: 'View in AR',

    // EmptyState
    emptyStateTitle: 'No dishes found',
    emptyStateSearchMsg: 'We couldn\'t find any dishes matching "{{query}}". Try different keywords or browse our categories.',
    emptyStateCategoryMsg: 'No dishes available in this category at the moment.',
    clearSearch: 'Clear Search',

    // PromotionsPopup
    promoClose: 'Close',
    promoPrev: 'Previous',
    promoNext: 'Next',
    
    // Dish Details
    category: 'Category',
    price: 'Price',
    servingSize: 'Serving Size',
    prepTime: 'Prep Time',
    calories: 'Calories',
    ingredients: 'Ingredients',
    allergens: 'Allergens',
    nutritionalInfo: 'Nutritional Information',
    protein: 'Protein',
    carbs: 'Carbs',
    fat: 'Fat',
    description: 'Description',
    
    // Reviews
    reviews: 'Reviews',
    review: 'review',
    verified: 'Verified',
    
    // AR Viewer
    cameraAccessRequired: 'Camera Access Required',
    cameraAccessMessage: 'To experience dishes in augmented reality, please enable camera access in your browser settings.',
    arTip: 'Use controls to rotate, zoom, and explore the dish in 3D. Tap camera to capture and share your AR view.',
    tip: 'Tip',
    
    // Admin Dashboard
    qrCodeGenerator: 'QR Code Generator',
    createCustomize: 'Create and customize QR codes for your restaurant menu',
    dashboard: 'Dashboard',
    batchGenerate: 'Batch Generate',
    totalGenerated: 'Total Generated',
    totalScans: 'Total Scans',
    activeCodes: 'Active Codes',
    thisWeek: 'this week',
    vsLastMonth: 'vs last month',
    locations: 'locations',
    
    // QR Code
    bestPractices: 'Best Practices for QR Code Deployment',
    bestPracticesDesc: 'Follow these guidelines to maximize customer engagement',
    optimalPlacement: 'Optimal Placement',
    optimalPlacementDesc: 'Place QR codes at eye level on tables, walls, and entrance areas for easy scanning',
    sizeMatters: 'Size Matters',
    sizemattersDesc: 'Minimum 2x2 inches for table tents, larger for wall posters and outdoor signage',
    clearInstructions: 'Clear Instructions',
    clearInstructionsDesc: 'Add "Scan to view menu" text near QR codes to guide customers',
    regularTesting: 'Regular Testing',
    regularTestingDesc: 'Test QR codes weekly to ensure they work across different devices and lighting',
    vsLastMonthLabel: 'vs last month',

    // QR Customization Panel
    customizeQRCode: 'Customize QR Code',
    personalizeQRDesc: "Personalize your restaurant\'s QR code design",
    basicInformation: 'Basic Information',
    restaurantNameLabel: 'Restaurant Name',
    restaurantNamePlaceholder: 'Enter restaurant name',
    menuUrlLabel: 'Menu URL',
    menuUrlPlaceholder: 'https://yourmenu.com/restaurant',
    menuUrlDesc: 'This URL will be encoded in the QR code',
    designOptions: 'Design Options',
    qrCodeColor: 'QR Code Color',
    includeRestaurantLogo: 'Include Restaurant Logo',
    includeRestaurantLogoDesc: 'Add your logo to the center of the QR code',
    addBorder: 'Add Border',
    addBorderDesc: 'Include a decorative border around the QR code',
    campaignSettings: 'Campaign Settings',
    promotionalMessage: 'Promotional Message',
    promotionalMessagePlaceholder: 'e.g., 20% off on first order',
    expirationDate: 'Expiration Date',
    expirationDateDesc: 'Leave empty for permanent QR code',
    generateQRCode: 'Generate QR Code',
    
    // Admin Dashboard
    restaurantAdminDashboard: 'Restaurant Admin Dashboard',
    manageMenu: 'Manage your menu, track analytics, and customize your digital presence',
    totalQRScans: 'Total QR Scans',
    arEngagements: 'AR Engagements',
    popularDishes: 'Popular Dishes',
    revenueInsights: 'Revenue Insights',
    thisMonth: 'This month',
    totalARViews: 'Total AR views',
    highEngagement: 'High engagement',
    monthlyTotal: 'Monthly total',
    
    // Actions
    save: 'Save',
    share: 'Share',
    duplicate: 'Duplicate',
    reset: 'Reset',
    download: 'Download',
    upload: 'Upload',
    edit: 'Edit',
    delete: 'Delete',
    add: 'Add',
    cancel: 'Cancel',
    generate: 'Generate',
    test: 'Test',
    
    // Common
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    search: 'Search',
    filter: 'Filter',
    sort: 'Sort',
    view: 'View',
    details: 'Details',
    loading: 'Loading',
    error: 'Error',
    success: 'Success'
  },
  
  fr: {
    // Navigation
    backToMenu: 'Retour au menu',
    viewInAR: 'Voir en RA',
    close: 'Fermer',
    back: 'Retour',
    next: 'Suivant',
    previous: 'Précédent',
    
    // Search and Filter
    searchPlaceholder: 'Rechercher des plats, ingrédients...',
    foundResults: '{{count}} {{unit}} trouvé(s)',
    dish: 'plat',
    dishes: 'plats',
    allDishes: 'Tous les plats',
    allCategories: 'Toutes les catégories',
    allStatus: 'Tous les statuts',
    
    // Categories
    appetizers: 'Entrées',
    appetizersDesc: 'Commencez votre voyage culinaire',
    mainCourse: 'Plat principal',
    mainCourseDesc: 'Plats copieux et satisfaisants',
    desserts: 'Desserts',
    dessertsDesc: 'Fins sucrées à retenir',
    beverages: 'Boissons',
    beveragesDesc: 'Boissons rafraîchissantes et cocktails',
    
    // Status
    active: 'Actif',
    inactive: 'Inactif',
    draft: 'Brouillon',
    
    // Restaurant Menu Landing
    whereTraditionMeets: 'Où la tradition rencontre l\'innovation',

    // Footer
    footerPhone: 'Téléphone',
    footerEmail: 'Adresse e-mail',
    footerAddress: 'Adresse',
    footerTerms: 'Modalités et Politiques',

    // DishCard
    viewInARButton: 'Voir en RA',

    // EmptyState
    emptyStateTitle: 'Aucun plat trouvé',
    emptyStateSearchMsg: 'Aucun plat ne correspond à « {{query}} ». Essayez d\'autres mots-clés ou parcourez nos catégories.',
    emptyStateCategoryMsg: 'Aucun plat disponible dans cette catégorie pour le moment.',
    clearSearch: 'Effacer la recherche',

    // PromotionsPopup
    promoClose: 'Fermer',
    promoPrev: 'Précédent',
    promoNext: 'Suivant',
    
    // Dish Details
    category: 'Catégorie',
    price: 'Prix',
    servingSize: 'Portion',
    prepTime: 'Temps de préparation',
    calories: 'Calories',
    ingredients: 'Ingrédients',
    allergens: 'Allergènes',
    nutritionalInfo: 'Informations nutritionnelles',
    protein: 'Protéines',
    carbs: 'Glucides',
    fat: 'Lipides',
    description: 'Description',
    
    // Reviews
    reviews: 'Avis',
    review: 'avis',
    verified: 'Vérifié',
    
    // AR Viewer
    cameraAccessRequired: 'Accès à la caméra requis',
    cameraAccessMessage: 'Pour vivre l\'expérience des plats en réalité augmentée, veuillez activer l\'accès à la caméra dans les paramètres de votre navigateur.',
    arTip: 'Utilisez les contrôles pour faire pivoter, zoomer et explorer le plat en 3D. Appuyez sur l\'appareil photo pour capturer et partager votre vue RA.',
    tip: 'Astuce',
    
    // Admin Dashboard
    qrCodeGenerator: 'Générateur de code QR',
    createCustomize: 'Créez et personnalisez des codes QR pour le menu de votre restaurant',
    dashboard: 'Tableau de bord',
    batchGenerate: 'Génération par lot',
    totalGenerated: 'Total généré',
    totalScans: 'Total de scans',
    activeCodes: 'Codes actifs',
    thisWeek: 'cette semaine',
    vsLastMonth: 'vs mois dernier',
    locations: 'emplacements',
    
    // QR Code
    bestPractices: 'Meilleures pratiques pour le déploiement de codes QR',
    bestPracticesDesc: 'Suivez ces directives pour maximiser l\'engagement des clients',
    optimalPlacement: 'Placement optimal',
    optimalPlacementDesc: 'Placez les codes QR à hauteur des yeux sur les tables, les murs et les zones d\'entrée pour une numérisation facile',
    sizeMatters: 'La taille compte',
    sizemattersDesc: 'Minimum 5x5 cm pour les chevalets de table, plus grand pour les affiches murales et la signalétique extérieure',
    clearInstructions: 'Instructions claires',
    clearInstructionsDesc: 'Ajoutez le texte « Scannez pour voir le menu » près des codes QR pour guider les clients',
    regularTesting: 'Tests réguliers',
    regularTestingDesc: 'Testez les codes QR chaque semaine pour vous assurer qu\'ils fonctionnent sur différents appareils et éclairages',
    vsLastMonthLabel: 'vs mois dernier',

    // QR Customization Panel
    customizeQRCode: 'Personnaliser le code QR',
    personalizeQRDesc: 'Personnalisez le design du code QR de votre restaurant',
    basicInformation: 'Informations de base',
    restaurantNameLabel: 'Nom du restaurant',
    restaurantNamePlaceholder: 'Entrez le nom du restaurant',
    menuUrlLabel: 'URL du menu',
    menuUrlPlaceholder: 'https://votremenu.com/restaurant',
    menuUrlDesc: 'Cette URL sera encodée dans le code QR',
    designOptions: 'Options de design',
    qrCodeColor: 'Couleur du code QR',
    includeRestaurantLogo: 'Inclure le logo du restaurant',
    includeRestaurantLogoDesc: 'Ajouter votre logo au centre du code QR',
    addBorder: 'Ajouter une bordure',
    addBorderDesc: 'Inclure une bordure décorative autour du code QR',
    campaignSettings: 'Paramètres de campagne',
    promotionalMessage: 'Message promotionnel',
    promotionalMessagePlaceholder: 'ex. : 20% de réduction sur la première commande',
    expirationDate: 'Date d\'expiration',
    expirationDateDesc: 'Laisser vide pour un code QR permanent',
    generateQRCode: 'Générer le code QR',
    
    // Admin Dashboard
    restaurantAdminDashboard: 'Tableau de bord administrateur du restaurant',
    manageMenu: 'Gérez votre menu, suivez les analyses et personnalisez votre présence numérique',
    totalQRScans: 'Total de scans QR',
    arEngagements: 'Engagements RA',
    popularDishes: 'Plats populaires',
    revenueInsights: 'Aperçu des revenus',
    thisMonth: 'Ce mois-ci',
    totalARViews: 'Total de vues RA',
    highEngagement: 'Engagement élevé',
    monthlyTotal: 'Total mensuel',
    
    // Actions
    save: 'Enregistrer',
    share: 'Partager',
    duplicate: 'Dupliquer',
    reset: 'Réinitialiser',
    download: 'Télécharger',
    upload: 'Téléverser',
    edit: 'Modifier',
    delete: 'Supprimer',
    add: 'Ajouter',
    cancel: 'Annuler',
    generate: 'Générer',
    test: 'Tester',
    
    // Common
    name: 'Nom',
    email: 'Courriel',
    phone: 'Téléphone',
    address: 'Adresse',
    search: 'Rechercher',
    filter: 'Filtrer',
    sort: 'Trier',
    view: 'Voir',
    details: 'Détails',
    loading: 'Chargement',
    error: 'Erreur',
    success: 'Succès'
  }
};

export default translations;